import { render, staticRenderFns } from "./HotelCard.vue?vue&type=template&id=4a8de8e2&scoped=true&"
import script from "./HotelCard.vue?vue&type=script&lang=js&"
export * from "./HotelCard.vue?vue&type=script&lang=js&"
import style0 from "./HotelCard.vue?vue&type=style&index=0&id=4a8de8e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8de8e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VHover,VRow})
